var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.500244C7.9 0.500244 7 1.40024 7 2.50024V2.79024C4.12 3.64024 2 6.32024 2 9.50024V15.5002L0 17.5002V18.5002H9.35C9.11864 17.8588 9.00022 17.1821 9 16.5002H4V9.50024C4 6.74024 6.24 4.50024 9 4.50024C11.76 4.50024 14 6.74024 14 9.50024V10.5902C14.6613 10.4702 15.3387 10.4702 16 10.5902V9.50024C16 6.32024 13.88 3.64024 11 2.79024V2.50024C11 1.96981 10.7893 1.4611 10.4142 1.08603C10.0391 0.710958 9.53043 0.500244 9 0.500244ZM7 19.5002C7.00006 19.9273 7.13682 20.3432 7.39027 20.6869C7.64372 21.0306 8.00055 21.2842 8.40852 21.4105C8.81649 21.5368 9.25418 21.5292 9.65751 21.3888C10.0608 21.2484 10.4086 20.9826 10.65 20.6302C10.33 20.2902 10.05 19.9102 9.81 19.5002H7Z",
    fill: "#04245C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.004 14.8372V16.3915M15.004 17.9459H15.008M18.8929 18.3345L15.6955 12.8942C15.6257 12.7746 15.5246 12.6751 15.4025 12.6059C15.2803 12.5367 15.1414 12.5002 15 12.5002C14.8586 12.5002 14.7197 12.5367 14.5976 12.6059C14.4754 12.6751 14.3743 12.7746 14.3046 12.8942L11.1071 18.3345C11.0366 18.4531 10.9997 18.5878 11 18.7248C11.0003 18.8618 11.0379 18.9963 11.1089 19.1147C11.1799 19.233 11.2818 19.331 11.4044 19.3987C11.5269 19.4664 11.6656 19.5014 11.8066 19.5002H18.2015C18.3417 19.5001 18.4794 19.4641 18.6009 19.3958C18.7223 19.3275 18.823 19.2294 18.8931 19.1113C18.9632 18.9932 19 18.8592 19 18.7228C19 18.5865 18.963 18.4525 18.8929 18.3345Z",
    stroke: "#2173FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanLoop);
export default __webpack_public_path__ + "static/media/human_loop.f2acf8d4710db2ea2c794c0a69773b82.svg";
export { ForwardRef as ReactComponent };